import PortalVue from 'portal-vue'
import Autocomplete from 'v-autocomplete'
import Vue from 'vue'

export default function () {
  Vue.use(PortalVue)
  Vue.use(Autocomplete)
}
